import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const riverApi = createApi({
    reducerPath: "core/river",
    baseQuery: axiosBaseQuery,
    tagTypes: ["riverList"],
    endpoints: (builder) => ({
        riverFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['riverList'],
            query: (query = '') => ({
                url: "/core/river" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        riverCreate: builder.mutation({
            invalidatesTags: ['riverList'],
            query: (data) => ({
                url: `/core/river`,
                method: "POST",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
        }),
        riverUpdate: builder.mutation({
            invalidatesTags: ['riverList'],
            // query: (data)=>({url: "/core/river/"+data.id, method: "PUT", data})
            query: (data) => ({
                url: `/core/river/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                } 
            })
        }),

        // console.log(data);

        riverDelete: builder.mutation({
            invalidatesTags: ['riverList'],
            query: (id) => ({ url: "/core/river/" + id, method: "DELETE" })
        }),
    })
})

export const { useRiverFindAllQuery, useRiverCreateMutation, useRiverUpdateMutation, useRiverDeleteMutation } = riverApi;
export { riverApi };
